import { render, staticRenderFns } from "./SideBarFull.vue?vue&type=template&id=23a76e18&scoped=true"
import script from "./SideBarFull.vue?vue&type=script&lang=js"
export * from "./SideBarFull.vue?vue&type=script&lang=js"
import style0 from "./SideBarFull.vue?vue&type=style&index=0&id=23a76e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a76e18",
  null
  
)

export default component.exports